import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
// import mutations from './store/mutations'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import './plugins/element.js'
import './plugins/echarts.js'
import './assets/css/iconfont/iconfont.css'
import echarts from 'echarts'
import {formatDate} from '@/filter'
// 引入mockjs
// import '@/mock/sysApiMock'

Vue.filter('formatDate', formatDate);
NProgress.configure({
    easing: 'ease',  // 动画方式
    speed: 500,  // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.3 // 初始化时的最小百分比
})
//当路由进入前
router.beforeEach((to, from, next) => {
    // 每次切换页面时，调用进度条
    NProgress.start();
    // 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了
    next();
});
//当路由进入后：关闭进度条
router.afterEach(() => {
    // 在即将进入新的页面组件前，关闭掉进度条
    NProgress.done()
})

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

// 阻止普通用户通过浏览器快捷键或右键菜单打开开发者工具（审查元素）或查看网页源代码
document.addEventListener('keydown', (e) => {
    if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
    ) {
        e.preventDefault();
    }
})
document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
